import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { CircularProgress, Drawer, Stack } from '@mui/material';
import { DealEventActivityViewModel } from '@trnsact/trnsact-shared-types';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

import { calendarApi } from '../../api';
import { EventCardMode } from '../../types';
import { useEventIdParam } from '../../hooks';
import { CalendarEventInfo } from './CalendarEventInfo';
import { CalendarEventUpdateForm } from './CalendarEventUpdateForm';

export const CalendarEventCard = ({ id }: Pick<DealEventActivityViewModel, 'id'>) => {
  const { closeEvent: handleClose } = useEventIdParam();
  const [mode, setMode] = useState<EventCardMode>(EventCardMode.Read);

  const { data, loading, previousData, error } = useQuery(calendarApi.dealActivity, { variables: { input: { id } } });

  const event = data?.dealActivity?.result?.entity ?? previousData?.dealActivity?.result?.entity;

  const renderByMode = {
    [EventCardMode.Read]: (
      <CalendarEventInfo event={event} onSwitchMode={() => setMode(EventCardMode.Write)} handleClose={handleClose} />
    ),
    [EventCardMode.Write]: <CalendarEventUpdateForm event={event} onSwitchMode={() => setMode(EventCardMode.Read)} />,
  };

  return (
    <Drawer anchor="right" open={Boolean(id)} onClose={handleClose}>
      <Stack
        width="100%"
        height="100%"
        padding="1rem"
        minWidth="30rem"
        maxWidth="30rem"
        direction="column"
        justifyContent="space-between"
      >
        <RenderWithFallback
          error={error}
          isLoading={loading}
          fallBack={
            <Stack alignItems="center" justifyContent="center" height="100%">
              <CircularProgress />
            </Stack>
          }
        >
          {renderByMode[mode]}
        </RenderWithFallback>
      </Stack>
    </Drawer>
  );
};
